export default {

    product: {
        'BindProductToScreen.036581-0': "Պատկերի գեներացման խափանում",
        'PreView.474740-0': "Պատկերը գեներացվում է, խնդրում ենք սպասել",
        'PreView.474740-1': "Պատկերի գեներացման սխալ"
    },
    menu: {

        retail_client_management: "Մանրածախ հաճախորդների կառավարում",

        template_list: "Ձևանմուշների ցանկ",

        picture_library: "Պատկերների գրադարան",

        mobile_api_management: "Բջջային API-ի կառավարում",

        open_api_management: "Բաց API-ի կառավարում",

        dashboard: "Վահանակ",

        system_setting: "Համակարգի կարգավորումներ",

        authorization_level: "Լիազորման մակարդակ",

        approval_flowchart: "Հաստատման հոսքագիծ",

        product_information: "Ապրանքի տվյալներ",

        retail_main_data: "Մանրածախ հիմնական տվյալներ",

        outlet: "Վաճառքի կետ",

        product: "Ապրանք",

        user_management: "Օգտատերերի կառավարում",

        user: "Օգտատեր",

        device_management: "Սարքերի կառավարում",

        gateway: "Դարպաս",

        screens: "Էկրաններ",

        price_management: "Գների կառավարում",

        price_change_events: "Գների փոփոխության իրադարձություններ",

        approval: "Հաստատում",

        approval_list: "Հաստատումների ցանկ",

        approval_log: "Հաստատումների մատյան",

        system_records: "Համակարգային գրառումներ",

        synchronized_logs: "Համաժամեցված մատյաններ",

        view_company: "Դիտել ընկերությունը",

        about: "Մեր մասին",

        view_profile: "Դիտել պրոֆիլը",

        logout: "Ելք",

        english: "Անգլերեն",

        chinese: "Չինարեն",

        indonesian: "Ինդոնեզերեն",

        thai: "Թայերեն",

        armenian: "Հայերեն",

        russian: "Ռուսերեն",

        language: "Լեզու",

        arabic: "Արաբերեն",

        back_to_login: "Վերադառնալ մուտքի էջ",

        online: "Առցանց",

        offline: "Անցանց",

        search_site: "Որոնել կայքում",

        hide_secretkey: "Թաքցնել SecretKey-ը",

        show_secretkey: "Ցուցադրել SecretKey-ը",

    },

};
